module.exports = __webpack_public_path__ + "static/media/linkup-thumbnail.3597604a.jpg";